import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class RoundIndicator extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, questionCount) {
    super(scene);

    this.bg = null;
    this.lblRound = null;
    this.lblNum = null;
    this.dots = null;
    this.questionCount = questionCount;

    this.bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._RoundIndicatorBg, this).setOrigin(0);

    this.lblRound = ABCyaPhaser.Text.addText(this.bg.width / 2, 14, 28,0xffffff, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString('round'), this, true).setOrigin(0.5);

    this.lblNum = ABCyaPhaser.Text.addText(this.bg.width / 2, 46, 42,0xffffff,FontKeys._bpreplaybold, ' ', this, true).setOrigin(0.5);

    const locs = [[13,14],[25,37],[44,56],[66,71],[92,77],[120,77],[146,71],[169,56],[187,37],[199,14]];
    this.dots = [];
    let item = null;

    for (let i = 0; i < this.questionCount; i++) {
      item = ABCyaPhaser.Images.addImage(locs[i][0] + 4, locs[i][1], UIAssetKeys._RoundIndicator_off, this);
      this.dots.push(item);
    }
  }

  initializeRound (roundNum) {
    this.lblNum.text = roundNum.toString();
  }

  setIndicator (index, value) {
    this.dots[index].setFrame(`RoundIndicator_${value}`);
  }
}